module.exports = __webpack_public_path__ + "static/media/Screencast.8db400be.png";